export default __webpack_public_path__ + "static/media/male_lungs-01.d10655d6.png";